import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'octo-uber-dialog',
    templateUrl: './uber-dialog.component.html',
    styleUrls: ['./uber-dialog.component.scss'],
})
export class UberDialogComponent {
    constructor(
        private modalRef: MatDialogRef<UberDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    unLinkAccount() {}
}
